import { render, staticRenderFns } from "./LeaveSettings.vue?vue&type=template&id=8f2e4510"
import script from "./LeaveSettings.vue?vue&type=script&lang=js"
export * from "./LeaveSettings.vue?vue&type=script&lang=js"
import style0 from "./LeaveSettings.vue?vue&type=style&index=0&id=8f2e4510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports